import { ModalTypes } from "../TargetTypeManagement";
import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeMsbList } from "../../ruleService";
import { showSuccessToast } from "../../../validation/ToastContainer";

export class MsbManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {

        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit MSB",
            text: "Select MSB",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedMsb: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {


        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove MSB",
            text: "Select MSBs",
            elements: this.elements,
            onSubmit: (msbList) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected MSBs?',
                        'Remove MSBs',
                        () => removeMsbList(msbList)
                            .then(() => setShowModal(false))
                            .then(() => showSuccessToast("MSBs were removed", "Remove MSB")),
                        undefined,
                        'Remove MSBs'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }
}
